module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"vehicle":"Vehicle","vrn":"License plate"},"de":{"vehicle":"Fahrzeug","vrn":"Kontrollschild"},"fr":{"vehicle":"Véhicule","vrn":"Plaque d\u0027immatriculation"},"it":{"vehicle":"Veicolo","vrn":"Targa"}}')
  delete Component.options._Ctor
}
